export enum GeoSamplePlatform {
    GMAPS = 'gmaps',
}
